import { useState } from 'react';
import { BaseInput, Button, Modal, Spinner } from '@shared/widgets';

type CardDetails = {
  label?: string | null;
  category?: string | null;
};

interface Props {
  show: boolean;
  onClose: () => void;
  onChangeLabel: (label: string) => void;
  onChangeCategory: (label: string) => void;
  initial: CardDetails;
  loading: boolean;
}

export const CardDetailsModal = (props: Props) => {
  const [category, setCategory] = useState<string>(props.initial.category || '');
  const [label, setLabel] = useState<string>(props.initial.label || '');

  const save = async () => {
    if (label !== props.initial.label) {
      await props.onChangeLabel(label);
    }
    if (category !== props.initial.category) {
      await props.onChangeCategory(category);
    }
    props.onClose();
  };

  const closeModal = () => {
    props.onClose();
    props.initial.category && setCategory(props.initial.category);
    props.initial.label && setLabel(props.initial.label);
  };

  return (
    <Modal isOpen={props.show} onClose={closeModal} title='Card details'>
      {props.loading ? (
        <Spinner />
      ) : (
        <>
          <div className='mb-5'>
            <BaseInput label='Card label' type='text' placeholder='Card label' value={label} onChange={setLabel} />
          </div>
          <div className='mb-5'>
            <BaseInput label='Card category' type='text' placeholder='Card category' value={category} onChange={setCategory} />
          </div>
          <div className='mt-7'>
            <Button color='primary' fullWidth onClick={save}>
              Save changes
            </Button>
          </div>
        </>
      )}
    </Modal>
  );
};
